<div class="modal-header">
  <h5 class="modal-title">{{ title }}</h5>
  <button type="button" class="close basic-close" data-dismiss="modal" aria-label="Close" (click)="onClose()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="col-md-12">
    <!-- Statistiques -->
    <div class="row mb-3">
      <div class="col-md-3">
        <div class="card bg-success text-white">
          <div class="card-body text-center">
            <h4>{{ totalNouveau }}</h4>
            <small>Nouveaux</small>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card bg-warning text-white">
          <div class="card-body text-center">
            <h4>{{ totalMiseAJour }}</h4>
            <small>Mises a jour</small>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card bg-danger text-white">
          <div class="card-body text-center">
            <h4>{{ totalErreur }}</h4>
            <small>Erreurs</small>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card bg-primary text-white">
          <div class="card-body text-center">
            <h4>{{ montantTotal | number }} {{ global.device }}</h4>
            <small>Montant Total</small>
          </div>
        </div>
      </div>
    </div>

    <!-- Periode -->
    <div class="row mb-3">
      <div class="col-md-12">
        <span class="badge badge-info f-14">Periode: {{ periode }}</span>
      </div>
    </div>

    <!-- Tableau de preview -->
    <div class="table-responsive">
      <table class="table table-striped table-bordered">
        <thead class="thead-dark">
          <tr>
            <th>#</th>
            <th>Contrat</th>
            <th>Locataire</th>
            <th>Porte</th>
            <th>Index Debut</th>
            <th>Index Fin</th>
            <th>Conso</th>
            <th>Montant</th>
            <th>Loyer Avant</th>
            <th>Loyer Apres</th>
            <th>Statut</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let line of previewData; let i = index" [class.table-danger]="line.statut === 'ERREUR'">
            <td>{{ line.ligne }}</td>
            <td>{{ line.contract }}</td>
            <td>{{ line.locataire || '-' }}</td>
            <td>{{ line.porte }}</td>

            <!-- Mode edition ou affichage -->
            <ng-container *ngIf="!line.editing">
              <td>{{ line.debut | number }}</td>
              <td>{{ line.fin | number }}</td>
              <td>{{ line.conso | number }}</td>
              <td>{{ line.montant | number }} {{ global.device }}</td>
              <td>{{ line.loyerAvant | number }} {{ global.device }}</td>
              <td>{{ line.loyerApres | number }} {{ global.device }}</td>
            </ng-container>

            <ng-container *ngIf="line.editing">
              <td>
                <input type="number" [(ngModel)]="line.debut" class="form-control form-control-sm" style="width: 80px;">
              </td>
              <td>
                <input type="number" [(ngModel)]="line.fin" class="form-control form-control-sm" style="width: 80px;">
              </td>
              <td>{{ line.fin - line.debut | number }}</td>
              <td>-</td>
              <td>{{ line.loyerAvant | number }} {{ global.device }}</td>
              <td>-</td>
            </ng-container>

            <td>
              <span class="badge" [ngClass]="getStatusBadgeClass(line.statut)">
                {{ line.statut }}
              </span>
              <small *ngIf="line.message" class="d-block text-muted">{{ line.message }}</small>
            </td>

            <td>
              <ng-container *ngIf="line.statut !== 'ERREUR'">
                <button *ngIf="!line.editing" (click)="editLine(line)" type="button"
                  class="btn btn-sm btn-warning mr-1" title="Modifier">
                  <i class="feather icon-edit"></i>
                </button>
                <button *ngIf="line.editing" (click)="saveLine(line)" type="button"
                  class="btn btn-sm btn-success mr-1" title="Sauvegarder">
                  <i class="feather icon-check"></i>
                </button>
                <button *ngIf="line.editing" (click)="cancelEdit(line)" type="button"
                  class="btn btn-sm btn-secondary mr-1" title="Annuler">
                  <i class="feather icon-x"></i>
                </button>
              </ng-container>
              <button (click)="removeLine(i)" type="button" class="btn btn-sm btn-danger" title="Supprimer">
                <i class="feather icon-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Message si aucune donnee -->
    <div *ngIf="previewData.length === 0" class="alert alert-info text-center">
      Aucune donnee a afficher
    </div>
  </div>
</div>

<div class="modal-footer">
  <button (click)="onClose()" type="button" class="btn btn-secondary" data-dismiss="modal">
    Annuler <i class="feather icon-x-circle"></i>
  </button>
  <button (click)="onValidate()" type="button" class="btn btn-success"
    [disabled]="submitting || (totalNouveau + totalMiseAJour) === 0">
    <span *ngIf="submitting">
      <i class="fa fa-spinner fa-spin"></i> Enregistrement...
    </span>
    <span *ngIf="!submitting">
      Valider et Enregistrer <i class="feather icon-save"></i>
    </span>
  </button>
</div>
